import { render, staticRenderFns } from "./uploadPicText.vue?vue&type=template&id=a46ab286&scoped=true"
import script from "./uploadPicText.vue?vue&type=script&lang=js"
export * from "./uploadPicText.vue?vue&type=script&lang=js"
import style0 from "./uploadPicText.vue?vue&type=style&index=0&id=a46ab286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46ab286",
  null
  
)

export default component.exports